import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {isNullOrUndefined} from '@shared/utils/utils';
import {MessageFormat} from '../models/file-element.model';
import {PresignedURLMessage} from '@modules/cases/models/PresignedUrlMessage';
import {ServiceMessage} from '@modules/cases/models/ServiceMessage';
import {WebsocketMessage} from '@modules/cases/models/WebsocketMessage';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {

  public socket$: any;

  private caseItemCreatedMessage = new Subject<WebsocketMessage>();
  public caseItemCreatedMessage$ = this.caseItemCreatedMessage.asObservable();

  private caseItemDeletedMessage = new Subject<WebsocketMessage>();
  public caseItemDeletedMessage$ = this.caseItemDeletedMessage.asObservable();

  private caseItemTypeChanged = new Subject<WebsocketMessage>();
  public caseItemTypeChanged$ = this.caseItemTypeChanged.asObservable();

  private caseItemStatusUpdate = new Subject<WebsocketMessage>();
  public caseItemStatusUpdate$ = this.caseItemStatusUpdate.asObservable();

  private caseStatusUpdate = new Subject<WebsocketMessage>();
  public caseStatusUpdate$ = this.caseStatusUpdate.asObservable();

  private serviceMessages = new Subject<ServiceMessage>();
  public serviceMessages$ = this.serviceMessages.asObservable();

  private presignedURLMessages = new Subject<PresignedURLMessage>();
  public presignedURLMessages$ = this.presignedURLMessages.asObservable();

  private pageDeleted = new Subject<WebsocketMessage>();
  public pageDeletedMessage$ = this.pageDeleted.asObservable();


  public sendMessage(action: string, message: any, apiKey: string): void {
    const messageToSend: MessageFormat = {
      action,
      message,
      apiKey
    };

    if (this.socket$) {
      this.socket$.next(messageToSend);
    }
  }

  public checkReceivedMessages(message: any) {
    if (isNullOrUndefined(message)) {
      // should not be possible
      console.log('Websocket service received empty message from server (happens?)');
      return;
    }

    if (!isNullOrUndefined(message.service)) {
      this.checkAndSendServiceMessage(message);
      return;
    }

    let jsonMessage = null;
    try {
      jsonMessage = JSON.parse(message);
    } catch (e) {
      console.log('Received invalid websocket message', message);
      return;
    }

    if (jsonMessage.message === 'Case item successfully deleted!') {
      this.caseItemDeletedMessage.next(jsonMessage);
    } else if (jsonMessage.message === 'Case item successfully created!') {
      this.caseItemCreatedMessage.next(jsonMessage);
    } else if (jsonMessage.message === 'Case successfully updated!') {
      this.caseStatusUpdate.next(jsonMessage);
    } else if (jsonMessage.message === 'Case item page successfully deleted!') {
      this.pageDeleted.next(jsonMessage);
    } else if (jsonMessage.message === 'Case item successfully updated!') {
      if (!isNullOrUndefined(jsonMessage.status)) {
        this.caseItemStatusUpdate.next(jsonMessage);
      }
      if (!isNullOrUndefined(jsonMessage.type)) {
        this.caseItemTypeChanged.next(jsonMessage);
      }
      if (!isNullOrUndefined(jsonMessage.presignedUrls)) {
        const typedMessage: PresignedURLMessage = {
          caseItemId: jsonMessage.id,
          presignedUrls: jsonMessage.presignedUrls,
          S3Objects: jsonMessage.S3Objects,
          retriesPerPage: jsonMessage.retriesPerPage
        };
        this.presignedURLMessages.next(typedMessage);
      }
    } else {
      console.log('Received unhandled websocket message', message);
    }
  }

  private checkAndSendServiceMessage(message) {
    if (!isNullOrUndefined(message.caseId) && !isNullOrUndefined(message.caseItemId) && !isNullOrUndefined(message.page) && !isNullOrUndefined(message.serviceStatus)) {
      const serviceMessage: ServiceMessage = {
        caseId: message.caseId,
        caseItemId: message.caseItemId,
        page: parseInt(message.page, 10),
        service: message.service,
        serviceStatus: message.serviceStatus,
        serviceResult: message.serviceResult
      };

      this.serviceMessages.next(serviceMessage);
    } else {
      console.log('Malformed service message !', message);
    }
  }
}
